import React from 'react'

import { clsx } from 'clsx'

import { ButtonClick, track } from '@dfds-frontend/tracking'

const getDataAttribute = (key: string): string => `${key?.toLowerCase()}-filter`

const trackToggle = (returnLeg: boolean, resourceKey: string): void => {
  const textToTrack = resourceKey?.split('-')?.pop() // for backwards compatibility tracking wise it needs to take the last "element" from the resource key, i.e. TIME-FILTER-SHOW-EVENING -> EVENING
  track<ButtonClick>({
    clickedElementText: textToTrack?.toLowerCase() || '',
    event: 'buttonClick',
    eventAction: `FilterDeparture${returnLeg ? 'Return' : 'Outward'}Clicked`,
  })
}

interface TimeChipProps {
  noMarginLeft?: boolean
  onToggle: () => void
  resourceKey: string
  returnLeg?: boolean
  selected: boolean
  timeInterval: string
}

const FilterChip = ({ onToggle, resourceKey, returnLeg, selected, timeInterval }: TimeChipProps): React.ReactElement => {
  return (
    <button
      className={clsx(
        'focus-visible:outline-semantic-global-primary-default typography-body-md-medium px-semantic-global-md py-semantic-global-xs flex w-full cursor-pointer items-center justify-center whitespace-nowrap outline-transparent select-none focus-visible:outline-2 focus-visible:outline-offset-2',
        selected
          ? 'bg-semantic-global-background-light-sky-blue text-semantic-global-primary-default border-semantic-global-primary-default border'
          : 'bg-semantic-global-background-white border-semantic-global-border-default hover:border-semantic-global-primary-default text-semantic-global-text-default hover:text-semantic-global-primary-default border transition-colors duration-150'
      )}
      data-e2e={getDataAttribute(resourceKey)}
      onClick={() => {
        onToggle()
        trackToggle(returnLeg ?? false, resourceKey)
      }}
      tabIndex={0}
      type="button"
    >
      {timeInterval}
    </button>
  )
}

export default FilterChip
